import * as React from "react";
const SvgFiBrandsDevianart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="m9.347 11.228-.375-.435H4.763V4.8h7.656l.674-.437L15.237.439 15.692 0h4.544v4.364l-4.582 8.405.374.438h4.208V19.2h-7.655l-.674.437-2.145 3.924-.454.439H4.764v-4.364z"
    />
  </svg>
);
export default SvgFiBrandsDevianart;
